module.exports = __webpack_public_path__ + "img/pocket-12_jp.c6c58c6.jpg";